import React, { useMemo } from 'react'

import { useOperatorData } from '@contexts/operator/OperatorDataContext'
import { useIsStandard } from '@contexts/operator/PlanContext'
import { useOperatorNotification } from '@contexts/operator/OperatorNotificationContext'
import InventoryMovementsList from '@shared/inventory_movements/List'
import ListPageHeader from '@shared/ListPageHeader'

import { inventoryMovementService } from '@services/operator/inventoryMovementService'
import { inventoryTypeService } from '@services/operator/inventoryTypeService'

export default function OperatorInventoryMovementsList() {
  const { merchants } = useOperatorData()
  const isStandard = useIsStandard()
  const { addJob } = useOperatorNotification()

  const merchantOptions = useMemo(() => {
    return merchants.map(merchant => ({
      label: merchant.name,
      value: merchant.id
    }))
  }, [merchants])

  return (
    <div>
      <ListPageHeader items={['stocks', 'stocks.inventory_movements']} />
      <InventoryMovementsList
      service={inventoryMovementService}
      inventoryTypeService={inventoryTypeService}
      role="operator"
      merchants={merchantOptions}
      addJob={addJob}
      hideMerchantUI={isStandard}
    />
    </div>
  )
}
